import { createApp } from 'vue'
import App from './App.vue'
import { initRem } from '@/common/js/rem'

// 初始化 rem 设置
// initRem()

const app = createApp(App)
app.mount('#app')
